<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Address Select"
    seFeDataSubtitle="An address component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <div>
      <se-fe-card>
        <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
        <se-fe-card-content>
          <p>Use this component for address inputs.</p>
          <p>If one or more fields are filled in, all fields will be required.</p>
          <p>Uses the following ui-components</p>
          <ul>
            <li>
              <a routerLink="/libs/ui-country-select">&#64;se-po/shared-ui-country-select</a>
            </li>
            <li>
              <a routerLink="/libs/ui-state-select">&#64;se-po/shared-ui-state-select</a>
            </li>
          </ul>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card>
        <se-fe-card-header seFeDataTitle="AddressValueFields"></se-fe-card-header>
        <se-fe-card-content>
          <se-fe-docs-table
            [seFeDataHeaders]="headers"
            [seFeDataRows]="addressValueFields">
          </se-fe-docs-table>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card class="form-example">
        <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-address-example></se-po-address-example>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card class="form-example">
        <se-fe-card-header seFeDataTitle="Pre-filled Example Code"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-populated-address-example></se-po-populated-address-example>
        </se-fe-card-content>
      </se-fe-card>
    </div>
  </div>
</se-fe-page>
<se-fe-toast></se-fe-toast>
